var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { typography } from '@dixa/lib-shared-tokens';
import { MSAA_QUALITY, Texture } from 'pixi.js';
export const iconSize = 24;
export const defaultIconSettings = {
    fill: typography.color.primary,
    size: iconSize,
};
export const iconTextureCacheMap = new Map();
export const getIconTextures = (attributes, iconSettings = defaultIconSettings) => __awaiter(void 0, void 0, void 0, function* () {
    if (!iconTextureCacheMap.has(iconSettings)) {
        iconTextureCacheMap.set(iconSettings, {});
    }
    const cache = iconTextureCacheMap.get(iconSettings);
    const iconLoadPromises = attributes.reduce((promiseMap, iconName) => {
        const cachedIconTexture = cache[iconName];
        if (cachedIconTexture) {
            promiseMap[iconName] = Promise.resolve(cachedIconTexture);
        }
        else {
            const url = getIconAsBlobURL(iconName, iconSettings);
            const texture = Texture.fromURL(url, {
                multisample: MSAA_QUALITY.HIGH,
            });
            promiseMap[iconName] = texture;
        }
        return promiseMap;
    }, {});
    const iconLoadKeys = Object.keys(iconLoadPromises);
    const iconLoadValues = Object.values(iconLoadPromises);
    return Promise.all(iconLoadValues).then((values) => {
        const icons = {};
        iconLoadKeys.forEach((name, index) => {
            const texture = values[index];
            const iconName = name;
            cache[iconName] = texture;
            icons[iconName] = texture;
        });
        return icons;
    });
});
export const getIconAsBlobURL = (name, iconSettings = defaultIconSettings) => {
    if (!name) {
        throw new Error('Missing icon name');
    }
    const symbol = document.querySelector(`#icon-${name}-${iconSize}`);
    if (!symbol) {
        throw new Error(`No icon with name "${name}"`);
    }
    const viewBox = symbol.getAttribute('viewBox') || '';
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    const { fill = defaultIconSettings.fill, size = defaultIconSettings.size } = iconSettings;
    svg.setAttribute('viewBox', viewBox);
    svg.setAttribute('fill', fill);
    svg.setAttribute('width', `${size * 2}px`);
    svg.setAttribute('height', `${size * 2}px`);
    // TODO: [TEAMS-12082] Investigate improper use of innerHTML
    svg.innerHTML = symbol.innerHTML;
    const serializer = new XMLSerializer();
    const svgAsString = serializer.serializeToString(svg);
    const blob = new Blob([svgAsString], { type: 'image/svg+xml' });
    const url = URL.createObjectURL(blob);
    return url;
};
